module.exports = __webpack_public_path__ + "static/img/cert-banner.c8c7ba0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/cert-banner.png
// module id = t0/v
// module chunks = 0